import { PERMISSIONS } from "@/shared/constants/permissions";

// Role hierarchy definitions - Single source of truth for role structure
export interface RoleDefinition {
  name: string;
  permissions: string[];
  inherits?: string[];
}

// Role hierarchy: Viewer → Driver → Scheduler → Dispatcher → Supervisor → Admin
export const ROLE_DEFINITIONS: Record<string, RoleDefinition> = {
  viewer: {
    name: "viewer",
    permissions: [PERMISSIONS.TRIP_VIEW, PERMISSIONS.VEHICLE_VIEW],
  },
  driver: {
    name: "driver",
    permissions: [PERMISSIONS.TRIP_VIEW, PERMISSIONS.VEHICLE_VIEW],
    inherits: ["viewer"],
  },
  scheduler: {
    name: "scheduler",
    permissions: [
      PERMISSIONS.METAROUTE_VIEW,
      PERMISSIONS.METAROUTE_UPDATE,
      PERMISSIONS.TRIP_VIEW,
    ],
    inherits: ["viewer"],
  },
  dispatcher: {
    name: "dispatcher",
    permissions: [
      PERMISSIONS.TRIP_VIEW,
      PERMISSIONS.TRIP_CREATE,
      PERMISSIONS.TRIP_UPDATE,
      PERMISSIONS.TRIP_CHANGE_TARGET_RUNS_OPERATION,
      PERMISSIONS.VEHICLE_VIEW,
      PERMISSIONS.VEHICLE_ASSIGN_OPERATION,
      PERMISSIONS.METAROUTE_VIEW,
      PERMISSIONS.METAROUTE_UPDATE,
      PERMISSIONS.CUSTOMER_VIEW,
      PERMISSIONS.CUSTOMER_CREATE,
      PERMISSIONS.CUSTOMER_UPDATE,
      PERMISSIONS.COMPANY_VIEW,
      PERMISSIONS.USER_VIEW,
      PERMISSIONS.CONFIGURATION_VIEW,
    ],
    inherits: ["scheduler"],
  },
  supervisor: {
    name: "supervisor",
    permissions: [
      PERMISSIONS.CUSTOMER_VIEW,
      PERMISSIONS.CUSTOMER_UPDATE,
      PERMISSIONS.REPORTING_ACCESS,
      PERMISSIONS.COMPANY_VIEW,
      PERMISSIONS.COMPANY_UPDATE,
    ],
    inherits: ["dispatcher"],
  },
  admin: {
    name: "admin",
    permissions: Object.values(PERMISSIONS),
    inherits: ["supervisor"],
  },
};

// Get role definition by name
export const getRoleDefinition = (
  roleName: string,
): RoleDefinition | undefined => {
  return ROLE_DEFINITIONS[roleName];
};

// Check if role exists
export const isValidRole = (roleName: string): boolean => {
  return roleName in ROLE_DEFINITIONS;
};
